import { render } from "./MobileButtons.vue?vue&type=template&id=7c8ae0fa&scoped=true"
import script from "./MobileButtons.vue?vue&type=script&lang=js"
export * from "./MobileButtons.vue?vue&type=script&lang=js"

import "./MobileButtons.vue?vue&type=style&index=0&id=7c8ae0fa&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8ae0fa"]])

export default __exports__